import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useLayoutEffect, useState } from 'react';

import { company } from '~/company/Company';
import { useLang } from '~/hooks/useLang';
import { userStore } from '~/stores/UserStore';

import DropDownSelector from '../DropDownSelector/DropDownSelector';

import { LOCALE } from './constants';
import styles from './LanguageSelector.module.scss';

const LanguageSelector = ({
  dropdownClassNames,
}: {
  dropdownClassNames?: string;
}) => {
  const { setLanguage } = useLang();
  const [curLangNum, setCurLangNum] = useState(0);

  useLayoutEffect(() => {
    const idx = company.config.langs.indexOf(
      userStore.lang || company.config.lang,
    );
    setCurLangNum(idx);
  }, []);

  if (!company.config.langs || company.config.langs.length < 2) {
    return null;
  }

  const nextLangNum =
    curLangNum + 1 < company.config.langs.length ? curLangNum + 1 : 0;

  const handleChangeLang = (nextNum: number | string) => {
    setCurLangNum(+nextNum);
    const nextLang = company.config.langs[+nextNum];
    if (nextLang) {
      setLanguage(nextLang);
    }
  };

  if (company.config.langs.length > 2) {
    return (
      <DropDownSelector
        currentValue={userStore.lang}
        selectedClassNames={styles.selected}
        optionClassNames={styles.option}
        classNames={dropdownClassNames}
        clickHandler={handleChangeLang}
        options={company.config.langs.map((lang) => ({
          value: lang,
          label: (
            <div className={classes([styles.root, styles.dark])}>
              <img src={LOCALE[lang as keyof typeof LOCALE].img} />
              <span>{LOCALE[lang as keyof typeof LOCALE].title}</span>
            </div>
          ),
        }))}
      />
    );
  }

  return (
    <button
      data-button="header-change-language"
      className={styles.root}
      onClick={() => handleChangeLang(nextLangNum)}
    >
      <img
        src={
          LOCALE[company.config.langs[nextLangNum] as keyof typeof LOCALE].img
        }
        alt=""
      />
      <span>
        {LOCALE[company.config.langs[nextLangNum] as keyof typeof LOCALE].title}
      </span>
    </button>
  );
};

export default observer(LanguageSelector);
